// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rQyU","input":"styles_input__1fLXJ"};